import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AboutUsComponent } from '@component/peripherals/about-us/about-us.component';
import { AgbComponent } from '@component/peripherals/agb/agb.component';
import { CareerComponent } from '@component/peripherals/career/career.component';
import { ContactComponent } from '@component/peripherals/contact/contact.component';
import { ImpressumComponent } from '@component/peripherals/impressum/impressum.component';
import { PrivacyComponent } from '@component/peripherals/privacy/privacy.component';
import { SharedModule } from './shared.module';
import { ImageSliderComponentModule } from '@component/generic/image-slider/image-slider.component';
import { JobCardComponentModule } from '@component/generic/cards/job-card/job-card.component';

@NgModule({
  declarations: [
    AboutUsComponent,
    ContactComponent,
    CareerComponent,
    AgbComponent,
    PrivacyComponent,
    ImpressumComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: 'ueber-uns',
        component: AboutUsComponent,
      },
      {
        path: 'peripherals/contact',
        component: ContactComponent,
      },
      {
        path: 'peripherals/career',
        component: CareerComponent,
      },
      {
        path: 'peripherals/agb',
        component: AgbComponent,
      },
      {
        path: 'peripherals/privacy',
        component: PrivacyComponent,
      },
      {
        path: 'peripherals/impressum',
        component: ImpressumComponent,
      },
    ]),
    ImageSliderComponentModule,
    JobCardComponentModule,
  ],
  exports: [SharedModule],
})
export class PeripheralModule {}
